<template>
  <Row justify="center" type="flex">
    <Col span="24">
      <div style="display: flex; width: 98%">
        <div style="display: flex; width: 102%; margin-bottom: 20px">
          <transition name="fade">
            <div class="newss">关于我们</div>
          </transition>
        </div>
      </div>
      <div class="about_content">
        <div>
          <div style="display: flex">
            <div style="width: 3px; height: 32px; background-color: #337ab7">
              |
            </div>
            <div
              style="
                color: #498ad4;
                font-size: 22px;
                font-family: 微软雅黑, serif;
                margin: 0 0 0 14px;
              "
            >
              河南南秀数智科技有限公司
            </div>
          </div>
          <div style="margin-top: 12px">
            <span class="div_content_sp">
              河南南秀数智科技有限公司旨在为建筑行业提供专业的VR技术服务、AR技术服务等,
              公司内部拥有精通VR、AR、互动操作台、智能机器人、电子沙盘、
              人才团队，为您提供完整的三维可视化解决方案，体验震撼的虚拟现实环境、触摸操作三维景观，体验多种建筑智能化设备硬件产品。
              主要经营范围：VR\AR技术应用、大数据处理，计算机系统集成,
              智能机器人、电子沙盘、三维软件培训、全景图制作、智能机器人开发、电子沙盘开发、虚拟灭火系统、互动操作台软件。
              目前，河南南秀数智科技有限公司已成为河南省区域建筑安全教育、公共区域安全教育、施工工法样板、建筑施工立体展示以及智能人机
              交互等方面的知名企业，为智慧工地大数据平台管理应用在建筑信息化方面的应用做出了突出的贡献。
            </span>
          </div>
        </div>
        <div style="margin-top: 40px">
          <div style="display: flex">
            <div style="width: 3px; height: 32px; background-color: #337ab7">
              |
            </div>
            <div
              style="
                color: #498ad4;
                font-size: 22px;
                font-family: 微软雅黑, serif;
                margin: 0 0 0 14px;
              "
            >
              主营业务
            </div>
          </div>
          <div style="margin-top: 30px">
            <div class="div_title">互动操作台</div>
            <div class="div_content">
              <span class="div_content_sp"
                >结合时下前沿科技，利用人机交互、三维数字等多种技术手段实现用户体验。<br />
                （1）在建筑方面的应用可以宏观的运用于施工场地沙盘布置对施工场地展示并进行全方位展示施工场地的详细信息以及大致规划。<br />
                （2）全方位多视角漫游施工现场，减少领导视察施工现场时的安全隐患，并且更加清晰明了<br />
                （3）热点信息展示通过互动台内的信息展示区进行展示施工现场所发生的热点信息，以及注意事项，信息传播更加迅速直观。<br />
                （4）通过人工智能使用语音和视频丰富形象的对每项建筑的功能以及施工技术重难点进行讲解规划展示。<br />
              </span>
              <div style="width: 100%; margin: 40px 0px 0px 40px">
                <Row justify="center" type="flex">
                  <Col :xs="0" :sm="0" :lg="24" :xl="24">
                    <img
                      style="width: 84%; height: 450px; border-radius: 5px"
                      src="../../../static/img/AboutUs/科幻.jpg"
                      alt="暂无照片"
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <div style="margin-top: 34px">
            <div class="div_title">AR技术</div>
            <div class="div_content">
              <span class="div_content_sp"
                >目的是在屏幕上把虚拟世界套在现实世界并进行互动配合我公司开发的AR虚拟体验类软件使用方便不受场地
                限制，可随时随地打开手机使用。AR现实意义：通过先进的虚拟现实AR技术，令体验者至于虚拟的施工场
                景，配合正常安全流程的自主操作和剧情展示，能让使用者产生更加真实的感官享受，更加强调了施工过程中
                的安全技术要点的重要性。
              </span>
              <div style="width: 100%; margin: 40px 0 0 40px">
                <Row justify="center" type="flex">
                  <Col :xs="0" :sm="0" :lg="24" :xl="24">
                    <img
                      style="width: 84%; height: 450px; border-radius: 5px"
                      src="../../../static/img/AboutUs/AR1.jpg"
                      alt="暂无照片"
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <div style="margin-top: 34px">
            <div class="div_title">灭火体验系统</div>
            <div class="div_content">
              <span class="div_content_sp"
                >本系统集虚拟现实、系统仿真、声音仿真、人机交互等前沿技术于一体，高逼真模拟众多火灾情景，为使
                用人员提供身临其境的消防演练环境，操作过程中无真实明火等安全隐患，不受场地限制，可轻松满足大
                规模消防演练需求，充分提高训练效率，全面提升训练质量，极大节约使用成本。
              </span>
              <div style="width: 100%; margin: 40px 0 0 40px">
                <Row justify="center" type="flex">
                  <Col :xs="0" :sm="0" :lg="24" :xl="24">
                    <img
                      style="width: 84%; height: 450px; border-radius: 5px"
                      src="../../../static/img/AboutUs/outfire.jpg"
                      alt="暂无照片"
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <!-- <div style="margin-top: 34px">
            <div class="div_title">实测实量系统平台</div>
            <div class="div_content">
              <span class="div_content_sp"
                >通过移动终端+智能化数据采集设备+智能云端为一体的建筑数据智能化采集、汇总、分析、存储、展
                示的闭环数据信息化系统平台。打破了现有的数据采集多种弊端，可多快好省的完成项目施工进度，有
                力地促进了项目施工效率。
              </span>
              <div style="width: 100%; margin: 40px 0 0 80px">
                <Row justify="center" type="flex">
                  <Col :xs="0" :sm="0" :lg="24" :xl="24">
                    <img
                      style="width: 700px; height: 600px"
                      src="../../../static/img/AboutUs/shice.jpg"
                      alt="暂无照片"
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div> -->
          <div style="margin-top: 34px">
            <div class="div_title">智能机器人</div>
            <div class="div_content">
              <span class="div_content_sp"
                >用户可以远程遥控机器人，并且可以进行视频交流，通过屏幕和机器人的机械装置来实丰富的互动交流。<br />
                （1）机器人自建地图功能、自动行走、躲避障碍物和人、根据目标地点进行路径规划。<br />
                （2）可以设置指定的时间到指定的地点提醒。<br />
              </span>
              <div style="width: 100%; margin: 40px 0 0 100px">
                <Row justify="center" type="flex">
                  <Col :xs="0" :sm="0" :lg="24" :xl="24">
                    <img
                      style="width: 700px; height: 660px"
                      src="../../../static/img/photo/photo_robot.jpg"
                      alt="暂无照片"
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
export default {
  name: "CompanyProfile",
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
};
</script>

<style scoped>
.about_content {
  width: 100%;
  background-color: #ffffff;
  margin: 20px 0 20px 0;
}

.div_title {
  color: #498ad4;
  font-size: 20px;
  font-family: 微软雅黑, serif;
}

.div_content {
  margin: 14px 0 0 0;
}

.div_content_sp {
  font-family: 微软雅黑, serif;
  line-height: 26px;
  display: inline-block;
  width: 100%;
}

.newss {
  width: 100%;
  text-align: center;
  color: #1f1f1f;
  font-size: 40px;
  padding-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs/CompanyProfile.vue